import { Optional } from '@/generic/functional';
import { DiagnosticId } from '@/diagnostic/domain/DiagnosticId.ts';

const STORAGE_KEY = 'cleanapi.diagnostic.tracking';

export const saveTrackedDiagnostic = (id: DiagnosticId): void => {
  sessionStorage.setItem(STORAGE_KEY, id.value);
};

export const loadTrackedDiagnostic = (): Optional<DiagnosticId> =>
  Optional.ofNullable(sessionStorage.getItem(STORAGE_KEY)).map(DiagnosticId.of);

export const clearTrackedDiagnostic = (): void => {
  sessionStorage.removeItem(STORAGE_KEY);
};
